import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { defineMessages, injectIntl } from 'react-intl'

import {
  selectUserId,
  selectUsername,
  selectLoggedIn,
  selectCountryCode,
  selectUnitPreference,
} from 'services/user/selectors'

import * as yearInReviewActions from 'services/yearInReview/actions'
import Header from './Header/Header'
import Footer from './Footer/Footer'
import Personal from './Personal/Personal'
import Community from './Community/Community'

const mapStateToProps = (state) => ({
  site: state.site,
  isLoggedIn: selectLoggedIn(state),
  userId: selectUserId(state),
  username: selectUsername(state),
  userYear: state.yearInReview.userYearData,
  userCountry: selectCountryCode(state),
  userUnitPreference: selectUnitPreference(state),
  activeCards: state.yearInReview.activeCards,
  mobileNav: state.yearInReview.mobileNav,
})

const mapDispatchToActions = {
  ...yearInReviewActions,
}

export class YearInReview extends Component {
  static propTypes = {
    fetchUserYear: PropTypes.func.isRequired,
    toggleMobileNav: PropTypes.func.isRequired,
    activateStatCard: PropTypes.func.isRequired,
    shareOnFacebook: PropTypes.func,
    shareOnTwitter: PropTypes.func,
    clickAd: PropTypes.func,
    isLoggedIn: PropTypes.bool,
    route: PropTypes.object.isRequired,
    userId: PropTypes.number,
    activeCards: PropTypes.array,
    userYear: PropTypes.object,
    username: PropTypes.string,
    userCountry: PropTypes.string,
    intl: PropTypes.object,
    userUnitPreference: PropTypes.string,
    mobileNav: PropTypes.bool,
    site: PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string,
      shortName: PropTypes.string,
    }),
  }

  componentWillMount () {
    const {
      isLoggedIn,
      userId,
    } = this.props
    const year = this.props.route.path

    if (isLoggedIn) {
      this.props.fetchUserYear(userId, year)
    }
  }

  handleClickAd = (href) => {
    this.props.clickAd(href)
  }

  handleFacebookShare = () => {
    const url = window.location.href
    this.props.shareOnFacebook(url)
  }

  handleTwitterShare = () => {
    const siteName = this.props.site.name
    const twitterPostText = `I used ${siteName} to make 2017 count. Check out how.`
    this.props.shareOnTwitter(twitterPostText)
  }

  render () {
    const {
      activateStatCard,
      activeCards,
      isLoggedIn,
      userCountry,
      userYear,
      username,
      toggleMobileNav,
      site,
      mobileNav,
      userUnitPreference,
    } = this.props
    const { formatMessage } = this.props.intl
    const year = this.props.route.path
    const siteName = this.props.site.name

    const messages = defineMessages({
      metaTitle: {
        id: 'yearInReview.2017.meta.title',
        defaultMessage: '{ siteName } Year In Review',
        values: { siteName },
      },
    })
    const metaTitle = formatMessage(messages.metaTitle, { siteName })

    return (
      <div>
        <Helmet
          defaultTitle={metaTitle}
        />
        <Header
          isLoggedIn={isLoggedIn}
          mobileNav={mobileNav}
          onFacebookShare={this.handleFacebookShare}
          onTwitterShare={this.handleTwitterShare}
          site={site}
          toggleMobileNav={toggleMobileNav}
          year={year}
        />
        { userYear ?
          <Personal
            activateStatCard={activateStatCard}
            activeCards={activeCards}
            userCountry={userCountry}
            userUnitPreference={userUnitPreference}
            userYear={userYear}
            username={username}
            year={year}
          />
        : null }
        <Community
          activateStatCard={activateStatCard}
          activeCards={activeCards}
          isLoggedIn={isLoggedIn}
          userCountry={userCountry}
          username={username}
          userUnitPreference={userUnitPreference}
          year={year}
        />
        <Footer
          activateStatCard={activateStatCard}
          activeCards={activeCards}
          isLoggedIn={isLoggedIn}
          onFacebookShare={this.handleFacebookShare}
          onTwitterShare={this.handleTwitterShare}
          onAdClick={this.handleClickAd}
          userCountry={userCountry}
          year={year}
        />
      </div>
    )
  }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToActions)(YearInReview))



// WEBPACK FOOTER //
// ./src/components/yearInReview/2017/YearInReview.jsx